var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":"/adms_api_v0/media/file","accept":"image/*","before-upload":_vm.beforeUpload}},[_c('el-button',{attrs:{"slot":"trigger","size":"mini","type":"text"},slot:"trigger"},[_vm._v("更新图片")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }